import React, { Component } from "react";
import { Link } from "react-router-dom";
import Table from "../common/table";

class GroupsTable extends Component {
  columns = [
    {
      label: "Typ",
      path: "typ.nazev",
      content: (group) => (
        <Link
          to={`/skupiny/${group._id}`}
          className="text-dark text-decoration-none"
        >
          {group.typ.nazev}
        </Link>
      ),
    },
    {
      label: "Počet lidí",
      path: "pocetLidi",
    },
    {
      label: "Datum",
      path: "datum",
      additionalPath: "cas.od", // Kvůli řazení terapií postupně
    },
    {
      label: "Čas",
      path: "cas.od",
      content: (treatment) => (
        <span>
          {treatment.cas.od} - {treatment.cas.do}
        </span>
      ),
    },
    {
      key: "edit",
      content: (group) => (
        <button
          onClick={() => this.props.onEdit(group)}
          className="btn btn-info btn-sm"
        >
          Editovat
        </button>
      ),
    },
    {
      key: "delete",
      content: (group) => (
        <button
          onClick={() => this.props.onDelete(group)}
          className="btn btn-danger btn-sm"
        >
          Smazat
        </button>
      ),
    },
  ];

  render() {
    const { data, sortColumn, onSort } = this.props;
    return (
      <div className="responsive-table-scroll">
        <Table
          data={data}
          columns={this.columns}
          sortColumn={sortColumn}
          onSort={onSort}
        />
      </div>
    );
  }
}

export default GroupsTable;
